import { t } from "../../hooks/useAppTranslation";
import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useHistory } from "react-router-dom";
import { Prompt } from "react-router-dom";
import PopUp from "../PopUp/PopUp";
import * as H from "history";
import {
  isRouteBlock,
  blockRoute,
  unblockRoute,
} from "../../Services/BlockChangeRoute";


type Props = {
  forceAbortToPath?: string;
};

export const BlockUnsavedForm: React.FC<Props> = ({ forceAbortToPath }) => {
  const { dirty, isSubmitting } = useFormikContext() ?? {};
  const [popup, setPopup] = useState<any>(null);
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (dirty && !isSubmitting) {
      blockRoute();
    } else {
      unblockRoute();
    }
  }, [dirty]);

  const preventChangeRoute = (
    location: H.Location<unknown>
  ): boolean | string => {
    if (!showPopup) {
      setPopup({
        title: t('g-warning'),
        notification: t('g-operation-lose-unsaved-data'),
        type: "confirm",
        onClick: () => changeRoute(location),
      });
      setShowPopup(true);
      return false;
    }

    return true;
  };

  const changeRoute = (newLocationLink: H.Location) => {
    unblockRoute();

    forceAbortToPath
      ? history.push(forceAbortToPath)
      : history.push(newLocationLink);
  };

  return (
    <>
      {showPopup && (
        <PopUp
          type={popup.type}
          title={popup.title}
          notification={popup.notification}
          onClickEvent={popup.onClick}
          closePopUp={() => setShowPopup(false)}
        />
      )}

      <Prompt
        when={isRouteBlock() && !isSubmitting}
        message={preventChangeRoute}
      />
    </>
  );
};
